import { LoaderFunctionArgs, LoaderFunction } from 'react-router-dom'

import { eventsApi } from '../../services/events'
import {
  setEvent,
  setEventDetailsStep,
  setOptions,
  setSessions,
  setSubEvents,
} from '../../store.slice'
import type { AppStore } from '../../store'

export const eventLoader = (store: AppStore) =>
  (async ({ params }: LoaderFunctionArgs) => {
    const { eventId } = params
    const skip = !eventId || eventId === 'new' || Number.isNaN(Number(eventId))
    if (skip) return { event: null, sessions: [], subEvents: [] }

    const { data: eventData } = await store.dispatch(
      eventsApi.endpoints.getEvent.initiate(Number(eventId), { forceRefetch: true })
    )
    if (!eventData) return { event: null, sessions: [], subEvents: [] }

    const { data: sessionsData } = await store.dispatch(
      eventsApi.endpoints.listSessions.initiate(Number(eventId), { forceRefetch: true })
    )
    const { data: subEventsData } = await store.dispatch(
      eventsApi.endpoints.listSubEvents.initiate({ id: Number(eventId) }, { forceRefetch: true })
    )

    return { event: eventData, sessions: sessionsData ?? [], subEvents: subEventsData ?? [] }
  }) satisfies LoaderFunction

export const adminEventLoader = (store: AppStore) =>
  (async ({ params }: LoaderFunctionArgs) => {
    const { eventId } = params
    const skip = !eventId || eventId === 'new' || Number.isNaN(Number(eventId))
    if (skip) return { event: null, sessions: [], subEvents: [], options: [] }

    const { data: eventData } = await store.dispatch(
      eventsApi.endpoints.getEvent.initiate(Number(eventId), { forceRefetch: true })
    )
    if (!eventData) return { event: null, sessions: [], subEvents: [], options: [] }

    const { data: sessionsData } = await store.dispatch(
      eventsApi.endpoints.listSessions.initiate(Number(eventId), { forceRefetch: true })
    )
    const { data: subEventsData } = await store.dispatch(
      eventsApi.endpoints.listSubEvents.initiate({ id: Number(eventId) }, { forceRefetch: true })
    )
    const { data: optionsData } = await store.dispatch(
      eventsApi.endpoints.listOptions.initiate(Number(eventId), { forceRefetch: true })
    )

    store.dispatch(setEvent({ data: eventData, key: eventId }))
    store.dispatch(setSessions({ data: sessionsData ?? [], key: eventId }))
    store.dispatch(setSubEvents({ data: subEventsData ?? [], key: eventId }))
    store.dispatch(setEventDetailsStep({ data: 5, key: eventId }))
    store.dispatch(setOptions({ data: optionsData ?? [], key: eventId }))

    return {
      event: eventData,
      sessions: sessionsData ?? [],
      subEvents: subEventsData ?? [],
      options: optionsData ?? [],
    }
  }) satisfies LoaderFunction
